import React, {PropsWithChildren, useEffect, useState} from 'react';
import './ModalEmployee.scss'

interface IEmployeeModal {
    active: boolean,
    close: () => void
}

const ModalEmployee = ({active, close, children}: PropsWithChildren<IEmployeeModal>) => {
    const [closing, setClosing] = useState(false)

    const handleClose = () => {
        setClosing(true)
        setTimeout(() => {
            close();
        }, 500)
    }

    useEffect(() => {
        if(active){
            document.body.classList.add('modal-open')
        }
        return() => {
            document.body.classList.remove('modal-open')
        }
    }, [active]);
    // useEffect(() => {
    //     document.body.style.overflow = 'hidden'
    //     return () => {
    //         document.body.style.overflow = 'unset'
    //     }
    // }, []);

    return (
        <>
            {active ? <div className={`employee-modal ${closing ? 'employee-modal-closing' : ''}`} onClick={handleClose}>
                    <div className="employee-modal__body">
                        <p className="employee-modal__close-cross" onClick={handleClose}>&times;</p>
                        {children}
                    </div>
                </div>
                :
                <>
                </>
            }
        </>
    );
};

export default ModalEmployee;